export const COPY_PREFIX = 'search_perseus.filters.global.hourly_toggle';
